import { render, staticRenderFns } from "./courseSettleManage.vue?vue&type=template&id=f8e37c68&"
import script from "./courseSettleManage.vue?vue&type=script&lang=js&"
export * from "./courseSettleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports